const StarterLump = ({snowballStarterLump, setSnowballStarterLump}) => {
    return (
        <div className="standardFormWrap">
            <div className="formField">
                <p>
                    <span style={{fontWeight: 700}}>(Optional, but recommended)</span><br />
                    How much money do you have to start your snowball? Any extra you can put towards your debt will help you pay it off faster.
                </p>
                <label>Starter Lump Sum:</label>
                <input
                    type="number"
                    defaultValue={snowballStarterLump}
                    step="any"
                    min={0}
                    onChange={(e) =>
                        setSnowballStarterLump(parseFloat(e.target.value))
                    }
                />
            </div>
        </div>
    )
}

export default StarterLump